<template>
  <div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          направи<br>нещо
        </div>
      </div>
      <div class="info-box-content">
        да бъдеш по-добър
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          направи<br>нещо
        </div>
      </div>
      <div class="info-box-content">
        за общото благо
      </div>
    </div>
    <div class="info-box active d-flex mb-3 align-items-center">
      <div class="info-box-title">
        <div>
          направи<br>нещо
        </div>
      </div>
      <div class="info-box-content">
        за висша цел
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "november1st-slogan-component"
}
</script>

<style scoped>
.info-box {
  width: 300px;
}

.info-box-title {
  flex-basis: 120px;
  height: 80px;
  font-size: 1rem;
  text-transform: uppercase;
}
</style>
